import clsx from 'clsx'
import { memo } from 'react'

import Icon from '@/atoms/Icon'
import { AlertVariant, IconName } from '@/ts/Global'

function Alert(props: AlertProps) {
  const { className, message, variant = 'info' } = props

  return (
    <div
      className={clsx('flex items-center p-3 space-x-4 rounded-lg', className, {
        'bg-sbtaquamarine-100 text-sbtaquamarine-600': variant === 'success',
        'bg-sbtred-100 text-sbtred-600': variant === 'error',
        'bg-sbtblue-100 text-sbtblue-600': variant === 'info',
      })}
    >
      <Icon
        className={clsx('w-8 h-8 inline-block p-2 rounded-full flex-shrink-0', {
          'bg-sbtaquamarine-200': variant === 'success',
          'bg-sbtred-200': variant === 'error',
          'bg-sbtblue-200': variant === 'info',
        })}
        name={names[variant]}
      />
      <p className="text-xs font-medium sm:text-sm">{message}</p>
    </div>
  )
}

const names: Record<AlertVariant, IconName> = {
  success: 'check_mark',
  error: 'warning',
  info: 'info',
}

interface AlertProps {
  className?: string
  message: string | JSX.Element
  variant?: AlertVariant
}

export default memo(Alert)
